// Cache the result since user agent doesn't change during session
let cachedResult = null;

const isMobile = function () {
  if (cachedResult !== null) {
    return cachedResult;
  }

  // Modern approach: check for touch capability and screen size
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isMobileScreen = window.innerWidth <= 768 && window.innerHeight <= 1024;
  
  // Simplified user agent check for mobile keywords
  const mobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent
  );
  
  // Consider it mobile if it has touch AND (small screen OR mobile user agent)
  cachedResult = hasTouch && (isMobileScreen || mobileUserAgent);
  
  return cachedResult;
};

const isIOS = function () {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

export { isMobile, isIOS };

